import { DatadogProvider } from '@datadog/openfeature-browser'
import { OpenFeature } from '@openfeature/web-sdk'
import { setFeatureFlagProvider } from '@/plugins/featureFlags'

/**
 * Inicializa o provider de feature flags do Datadog (OpenFeature) e registra
 * um adapter síncrono em featureFlags/index.js.
 *
 * A inicialização é assíncrona (setProviderAndWait), mas as avaliações
 * posteriores via getFeatureFlag/getFlag são síncronas (Web SDK).
 *
 * Em falha de inicialização (rede, token inválido etc.) registra um provider
 * que retorna false e, em produção, não emite log no console.
 * Sem token configurado (ex.: dev local), mantém o fallback de featureFlags/index.js.
 *
 * @param {{ value: string, text: string }|null} partner Parceiro logado (empresa.codigo)
 */
export async function initFeatureFlags (partner) {
  try {
    const clientToken = process.env.VUE_APP_DD_CLIENT_TOKEN

    if (!clientToken) {
      return
    }

    const provider = new DatadogProvider({
      clientToken,
      site: process.env.VUE_APP_DD_SITE || 'datadoghq.com',
      env: process.env.VUE_APP_DD_ENV || process.env.NODE_ENV,
      service: process.env.VUE_APP_DD_SERVICE,
      version: process.env.VUE_APP_DD_VERSION,
      applicationId: process.env.VUE_APP_DD_APPLICATION_ID,
      enableExposureLogging: true,
      enableFlagEvaluationTracking: true
    })

    const context = {
      targetingKey: (partner && partner.value) || 'anonymous',
      partnerId: partner && partner.value,
      partnerName: partner && partner.text
    }

    await OpenFeature.setProviderAndWait(provider, context)

    setFeatureFlagProvider({
      getFlag: (key, def) => OpenFeature.getClient().getBooleanValue(key, def)
    })
  } catch (err) {
    setFeatureFlagProvider({
      getFlag: () => false
    })

    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.error('Falha ao inicializar feature flags do Datadog:', err)
    }
  }
}
